import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Law = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="76" viewBox="0 0 149 76" width="149" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M12.21 54.66c6.47 0 11.71-.45 11.71-1s-5.24-1-11.71-1-11.71.45-11.71 1 5.24 1 11.71 1Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m74.37 3.86-.02.04-.09.16-.05.1-.08.15c-.98 1.64-3.45 3.56-6.79 5.31a46 46 0 0 1-12.09 4.28c-3.84.78-7.06.82-8.83.09l-.04-.02-.44-.22h-.01a2 2 0 0 1-.9-1.02c-.6-1.69 1.7-4.18 5.65-6.5a45 45 0 0 1 7.44-3.4C66.26-.06 73.61-.3 74.53 2.28q.25.7-.15 1.58z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m70.36 18.14-.02.01a38 38 0 0 1-3.31 1.54q-1.25.54-2.6 1.01a42 42 0 0 1-6.21 1.72h-.01c-5.39 1.09-9.52.73-10.19-1.17-.41-1.14.52-2.66 2.38-4.23q.61.9.96 2.26c.55 1.57 6 1.07 12.17-1.11s10.71-5.23 10.15-6.8q-.16-1.32-.18-2.34c2.17.11 3.64.7 4.01 1.76.67 1.9-2.32 4.8-7.17 7.33z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M82.87 29.35c-1.02 1.42-3.05 3-5.74 4.5a45 45 0 0 1-6.71 2.98c-5.97 2.11-11.5 2.81-14.39 2.02-1.06-.29-1.76-.78-2.01-1.47-.47-1.33.84-3.12 3.32-4.96q.29 1.13.1 2.42-.06.5-.2 1.01.2.54 1.07.76c1.98.51 6.32-.18 11.09-1.86 4.93-1.74 8.82-4.04 9.9-5.69q.42-.62.26-1.09l-.58-.58a10 10 0 0 1-1.68-2.17c3.36-.24 5.73.33 6.23 1.73.25.69 0 1.52-.64 2.42z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M80.51 19.77c-.2 2.2-2.51 3.96-3.57 4.72q-.61.45-1.32.88h-.01q-2.03 1.28-4.62 2.45l-.88.38-.03.01a50 50 0 0 1-5.33 1.89h-.04q-3.11.9-5.77 1.23h-.01q-.99.13-1.89.18c-1.32.08-4 .64-5.86-1.19-2.33-2.31-2.96-7.18-3.17-9.06.67 1.9 4.8 2.26 10.19 1.17h.01a45 45 0 0 0 8.8-2.73q1.76-.73 3.3-1.54h.02c4.85-2.54 7.84-5.44 7.17-7.33.97 1.51 3.27 5.63 2.99 8.96z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M73.69 11.39c.55 1.57-3.99 4.61-10.15 6.8s-11.61 2.67-12.17 1.11a8 8 0 0 0-.96-2.26c-.95-1.47-2.32-2.22-4-3.04 1.77.73 4.98.69 8.83-.09a48 48 0 0 0 12.1-4.27c3.35-1.76 5.81-3.68 6.79-5.32q.05-.07.08-.15.01-.05.05-.1a14 14 0 0 0-.76 4.98q.02 1.02.18 2.34z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M79.3 29.05c-1.07 1.65-4.97 3.95-9.9 5.69-4.77 1.69-9.12 2.37-11.09 1.86q-.87-.22-1.07-.76.14-.51.2-1.01a6.3 6.3 0 0 0-.39-3.33q.9-.05 1.89-.18h.01a38 38 0 0 0 5.77-1.23h.04a47 47 0 0 0 5.33-1.89l.03-.01.88-.38a38 38 0 0 0 4.62-2.44h.01q.7-.45 1.32-.89.14.37.34.72c.43.8 1.02 1.49 1.68 2.17l.58.58q.16.47-.26 1.09z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M84.89 31.08c.09 1.83-1.84 4.05-6 6.43a45 45 0 0 1-7.1 3.21c-5.17 1.83-12.53 3.15-15.91 1.35-1.98-1.05-1.78-4.09-1.87-4.69.25.69.95 1.18 2.01 1.47 2.89.79 8.43.09 14.39-2.02a45 45 0 0 0 6.71-2.98c2.68-1.49 4.71-3.08 5.74-4.5.64-.9.89-1.73.64-2.42.91 1.11 1.34 3.27 1.38 4.15z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M52.98 30.89c-3.22 4.42-7.88 6.26-13.39 6.57 1.21-.6 1.38-2.74.38-4.79a4 4 0 0 0-.29-.52c-1.03-1.73-2.61-2.65-3.73-2.12 3.1-4.15 7.68-6.17 13.39-6.55a4.9 4.9 0 0 1 4.13 2.9c.83 2.78-.16 3.91-.49 4.51Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M39.59 37.45Q23.91 51.98 10.55 50.09c.8-.38.9-1.8.25-3.15l-.1-.18c-.67-1.24-1.79-1.93-2.55-1.56 6.62-9.7 16.53-13.78 27.79-15.18 1.11-.53 2.69.39 3.73 2.12q.16.24.29.52c1 2.04.83 4.19-.38 4.79z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M10.55 50.1c-.8.4-1.98-.39-2.64-1.73-.66-1.35-.55-2.76.25-3.16.76-.36 1.87.32 2.54 1.56l.1.18c.66 1.35.55 2.76-.25 3.15Z"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M12.2 53.03a6 6 0 0 1-2.44 1.5q.68-.35.91-1.3c.33-1.35-.02-3.45-1.06-5.56-1.11-2.29-2.71-3.94-4.05-4.36a1.7 1.7 0 0 0-1.28.02 5 5 0 0 1 2.19-1.34c1.43-.7 3.81 1.24 5.33 4.33 1.41 2.9 1.56 5.77.41 6.71z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M10.67 53.23q-.23.95-.91 1.3c-1.43.7-3.81-1.24-5.33-4.33-1.51-3.1-1.58-6.17-.16-6.88q.57-.26 1.28-.02c1.34.42 2.94 2.08 4.05 4.36 1.04 2.11 1.4 4.21 1.06 5.56z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M66.94 55.32c18.36 0 33.25-.67 33.25-1.5s-14.89-1.5-33.25-1.5-33.25.67-33.25 1.5 14.89 1.5 33.25 1.5Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M93.23 49.91c0 1.62-1.47 2.57-2.63 3.07q-1.12.46-2.35.46H47.01q-.8 0-1.58-.21c-1.33-.37-3.61-1.29-3.61-3.33s2.27-2.96 3.61-3.32a6 6 0 0 1 1.58-.21h41.07q.95 0 1.86.3c1.3.44 3.29 1.43 3.29 3.23z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M88.04 46.37H46.97l.8-1.24a5.4 5.4 0 0 1 4.55-2.49h30.33c1.8 0 3.49.91 4.49 2.41z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M112.65 26.03v5.69" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M115.7 28.87h-6.1" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M121.44 16.91V8.7" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M118.48 12.81h5.92" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M130.22 23.18c-.08.25 0 4.85 0 4.85" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M128.09 25.61h4.19" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m74.29 61.44-24.14 5.1c-.45.1-.43.75.03.81l58.17 7.57a7.6 7.6 0 0 0 5.73-1.6l14.2-11.33-54-.55z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M104.95 44.53c-13.71 7.36-28.99 12.12-49.17 15.28-.7.11-.77 1.09-.09 1.3 15.56 4.91 33.33 7.68 55.06 10.07 1.09.12 2.2-.07 3.18-.56 13.76-6.84 25.25-14.6 33.56-22.96.42-.42.1-1.15-.5-1.14-13.93.21-26.81-.53-38.24-2.61a5.8 5.8 0 0 0-3.79.6z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M111.32 56.24c.3-.94-3.61-1.58-5.79-.15-1.83 1.2.62 2.35 3.96 1.5" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M108.2 61.12c5.94-.14 10.71-2.18 10.65-4.56-.05-2.37-4.92-4.18-10.86-4.04s-10.7 2.19-10.65 4.56c.06 2.37 4.92 4.18 10.86 4.04Z"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
